export default __webpack_public_path__ + "assets/logo-dark.92f85ac2a1f35586b5b40c3708380886.png";